import { HttpErrorResponse } from '@angular/common/http';
import { PRICE_LIST_ERROR_CODES } from '@models/water-price-list';

/**
 * The message a failed price-list write earned. The API rejects two things by name — a start date
 * another price list of the lake already uses, and a change that would leave the lake with no price
 * list in effect — and each names exactly what the user has to do differently. Everything else falls
 * back to the caller's generic message.
 *
 * Shared by every price-list write so the same rejection cannot be worded three different ways.
 */
export function priceListErrorKey(error: unknown, fallbackKey: string): string {
  const code = error instanceof HttpErrorResponse ? error.error?.code : null;

  switch (code) {
    case PRICE_LIST_ERROR_CODES.duplicateStartDate:
      return 'waters.price-lists.duplicate-start-date';
    case PRICE_LIST_ERROR_CODES.noActivePriceList:
      return 'waters.price-lists.no-active-price-list';
    default:
      return fallbackKey;
  }
}
